import { render, staticRenderFns } from "./FeatureSettings.vue?vue&type=template&id=97a6325a&scoped=true&"
import script from "./FeatureSettings.vue?vue&type=script&lang=js&"
export * from "./FeatureSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a6325a",
  null
  
)

export default component.exports